import { isHexColor } from 'src/adminPanel/screens/inputs/validators'
import { TEntityOverride } from 'src/types'
import { IAgentStatus } from '@obvious.tech/constellation'

const override: TEntityOverride<IAgentStatus> = {
  titleField: 'name',
  global: {
    properties: {
      color: {
        type: 'color',
        validations: [isHexColor],
      },
      groups: {
        type: 'groups',
      },
    },
  },
}

export default override
